<template>
  <div id="app">
    <router-view v-if="isRouterAlive" />
    <!-- 审单通知 -->
    <div
      class="review-inform-dialog"
      :class="reviewInformShow ? 'popup-enter-active' : 'popup-leave-active'"
    >
      <div class="review-inform-head">
        <img style="width: 26px;height: 26px;margin-right: 10px;" src="./assets/images/small_bell.png" alt="">
        <span class="review-inform-head__title">来单啦！</span>
        <i
          class="el-dialog__close el-icon el-icon-close"
          @click="closeReviewInform"
        ></i>
      </div>
      <div class="review-inform-body">
        <img src="./assets/images/tip_solid.png" alt="" />
        <span>您有一个新的待审订单，请尽快审核！</span>
      </div>
      <div class="review-inform-footer">
        <div class="footer_btn"  @click="goToReviewOrder">去审单</div>
      </div>
    </div>
    <div v-show="false">
      <audio
        ref="myMusic"
        preload="auto"
        src="@/assets/music/examine.mp3"
      ></audio>
    </div>
    <el-dialog
      title="提示"
      :visible.sync="downlineVisible"
      width="400px"
      :close-on-click-modal="false">
      <div style="text-align: center;font-size: 16px;margin: 20px;color: #FF687B;">您当前被强制下线，请联系公司负责人。</div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downlineVisible = false">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
import _api from "@/utils/request";

export default {
  name: "App",
  provide() {
    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
    };
  },
  data() {
    return {
      isRouterAlive: true, //控制视图是否显示的变量
      reviewInformShow: false,
      userInfo: localStorage.getItem('user')?JSON.parse(localStorage.getItem('user')):{},
      downlineVisible: false,
    };
  },
  computed: {
    ...mapState({
      userOnline: (state) => state.tagsView.userOnline,
      isAudio: (state) => state.tagsView.isAudio,
      wsClient: (state) => state.tagsView.wsClient,
      isOnExamine: (state) => state.tagsView.isOnExamine,
    }),
  },
  mounted() {
    if(this.userInfo.examineQuoteUserEnable && this.userInfo.examineMode === '00'){
      _api.signState().then(res => {
        if(res.code === 1){
          this.$store.commit("tagsView/SET_USERONLINE", res.data);
        }
      })
    }
  },
  watch: {
    userOnline(val) {
      
      if(val){
        sessionStorage.setItem('userOnline', '01')
        this.$store.dispatch('tagsView/initWebSocketClient')
        this.wsClient.onMessage = (message) => {
          console.log('接收到的消息1111', message);
          let messageObj = JSON.parse(message)
          // {"code":1,"data":{"quId":"2","state":"00"},"msg":""}
          if(localStorage.getItem('user') && JSON.parse(localStorage.getItem('user')).examineQuoteUserId){
            if(messageObj.data.quId == JSON.parse(localStorage.getItem('user')).examineQuoteUserId && messageObj.data.state === '00'){
              this.$store.commit("tagsView/SET_USERONLINE", false);
              this.reload()
              this.$nextTick(()=>{
                this.downlineVisible = true
              })
            }
          }
          // let onExamine = sessionStorage.getItem('onExamine')==='true' || false
          console.log(this.isOnExamine,'this.isOnExaminethis.isOnExaminethis.isOnExamine');
          
          if(!this.isOnExamine && messageObj.data.orderNo){
            this.reviewInformShow = true
            console.log(this.isAudio,'this.isAudio');
            if(this.isAudio){
              this.clickMusic()
            }
          }
        };
      }else{
        sessionStorage.setItem('userOnline', '02')
        if(this.wsClient){
          this.wsClient.sendMessage(JSON.stringify({
            bodyType: "QuoteExaminePresence",
            body: {
              state: '00',
              quId: JSON.parse(localStorage.getItem('user')).examineQuoteUserId
            }
          }))
          this.wsClient.close()
        }
      }
    },
  },
  methods: {
    reload() {
      this.isRouterAlive = false; //先关闭，
      this.$nextTick(function() {
        this.isRouterAlive = true; //再打开
      });
    },
    closeReviewInform() {
      this.reviewInformShow = false;
    },
    goToReviewOrder() {
      this.reviewInformShow = false
      if (this.$route.path === "/reviewQuotation/pendingOrder") {
        let _this = this
        this.$router.replace({
          path: "/reviewQuotation/pendingOrder",
          query: {
              type:  'start',
          },
        },() => {
          _this.reload(); //刷新页面
        });
        return;
      }
      this.$router.push({ path: "/reviewQuotation/pendingOrder", query: { type:'start' } })
    },
    // 点击音乐图标
    clickMusic() {
      this.clickStopMusic(); // 先关闭音乐
      this.$refs.myMusic.play(); // 通过refs播放音乐
    },
    clickStopMusic() {
      this.$refs.myMusic.load(); // 停止音乐播放
    },
    handleGlobalClick(){
      this.$store.commit("tagsView/SET_AUDIOOPEN", true);
    }
    // beforeUnloadHandler(event) {
      // 这里可以编写你需要在页面关闭时执行的代码
      // console.log("页面即将关闭");
      // if(this.wsClient){
      //   this.wsClient.sendMessage(JSON.stringify({
      //     bodyType: "QuoteExaminePresence",
      //     body: {
      //       state: '00',
      //       quId: JSON.parse(localStorage.getItem('user')).examineQuoteUserId
      //     }
      //   }))
      // }
      // this.$store.commit("tagsView/SET_USERONLINE", false);
      // if(this.userInfo && this.userInfo.examineQuoteUserEnable){
      //   _api.examineSignOut()
      // }    
    // },
  },
  created() {
    document.addEventListener('click', this.handleGlobalClick);
    // window.addEventListener("beforeunload", this.beforeUnloadHandler);
  },
  beforeDestroy() {
    // if(this.wsClient){
    //   this.wsClient.sendMessage(JSON.stringify({
    //     bodyType: "QuoteExaminePresence",
    //     body: {
    //       state: '00',
    //       quId: JSON.parse(localStorage.getItem('user')).examineQuoteUserId
    //     }
    //   }))
    // }
    // this.$store.commit("tagsView/SET_USERONLINE", false);
    // if(this.userInfo && this.userInfo.examineQuoteUserEnable){
    //   _api.examineSignOut()
    // }
    // window.removeEventListener("beforeunload", this.beforeUnloadHandler);
  },
};
</script>

<style lang="scss">
@import "./assets/scss/app";

#app {
  width: 100%;
  min-height: 100%;
  background-color: #f5f6fa;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}
/*解决element表格对不齐*/
.el-table th {
  display: table-cell !important;
}

.el-tooltip__popper {
  max-width: 900px;
}

.lv_fc {
  color: #0981ff;
}

.lv_fc_red {
  color: #ff0000;
}

.lv_fc_line {
  color: #0981ff;
  text-decoration: underline;
  cursor: pointer;
}

.lv_f_line {
  text-decoration: underline;
}

//溢出隐藏单
.lv_ycyc1 {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

//2行
.lv_ycyc2 {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.review-inform-dialog {
  position: fixed;
  z-index: 99999999999999999998;
  right: 20px;
  bottom: 20px;
  width: 380px;
  background: #ffffff;
  border-radius: 16px;
  box-shadow: 0px 1px 8px 2px rgba(0, 0, 0, 0.13);
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease-in-out, opacity 0.3s ease-in-out;
  transform: translateY(100%);
  opacity: 0;
  &.popup-enter-active {
    transform: translateY(0);
    opacity: 1;
  }
  &.popup-leave-active {
    transform: translateY(100%);
    opacity: 0;
  }
  .review-inform-head {
    position: relative;
    height: 68px;
    padding-top: 30px;
    background-image: url('./assets/images/dialog_header.png');
    background-size: 100% 100%;
    border-radius: 16px 16px 0px 0px;
    display: flex;
    align-items: center;
    justify-content: center;
    .review-inform-head__title {
      font-weight: 500;
      font-size: 20px;
      color: #081A56;
      line-height: 28px;
    }
    .el-dialog__close {
      position: absolute;
      top: 20px;
      right: 20px;
      color: #516087;
      font-size: 28px;
      cursor: pointer;
      user-select: none;
    }
  }
  .review-inform-body {
    height: 82px;
    border-radius: 0 0 16px 16px;
    padding: 20px;
    font-weight: 500;
    font-size: 16px;
    color: #2A2A2A;
    line-height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 14px;
      height: 14px;
      margin-right: 6px;
    }
  }
  .review-inform-footer {
    padding: 0 0 20px;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    .footer_btn{
      width: 120px;
      height: 36px;
      background: #2D81FF;
      border-radius: 6px;
      font-weight: 400;
      font-size: 14px;
      color: #FFFFFF;
      line-height: 20px;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
    }
  }
}
</style>
